import Model from '~/models/Model';

export default class GraduationType extends Model {
  resource() {
    return 'v1/graduation-types';
  }
}
